(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('filesearch', {
      restrict: 'E',
      bindings: {
        file: '<',
        fileref: '<',
        parentsave: '&?',
        editinplace: '@?',
        ti: '@?'
      },
      template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showfile($item, $model, $label)"
                   uib-typeahead="file as file.text for file in vm.getFiles($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-refresh"></i>
        <div ng-show="noResults">
          <i class="fa fa-remove"></i> Keine SV gefunden
          <span class="btn btn-success" ng-click="vm.addFile()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>
          <span ng-click="vm.addFile()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true">
          <fileeditor file="vm.file"></fileeditor>
        </div>
        
        
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'FileHelper',
        function ($log, File, FileHelper) {
          let vm = this;
          vm.save = save;
          vm.showfile = showfile;

          vm.getFiles = getFiles;
          // vm.addFile = FileHelper.addFile;
          vm.addFile = addFile;
          vm.editFile = FileHelper.editFile;

          vm.$onInit = function () {
            vm.newfile = {};

            if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
              vm.editinplace = true;
            }

            $log.debug('debug - editinplace', vm.editinplace);


            if (angular.isUndefined(vm.ti)) {
              vm.ti = 0;
              vm.tabi = 0;
            }
            if (angular.isString(vm.ti)) {
              vm.tabi = parseInt(vm.ti, 10);
            }
            else {
              vm.tabi = 0;
            }
            vm.lastfile = angular.copy(vm.fileresult);
            vm.lastfileref = angular.copy(vm.fileref);
          };

          function addFile() {
            $log.debug('debug - filesearch addFile called');
            FileHelper.addFile(function (file) {
              $log.debug('debug: handle newly create file');
              vm.file = {};
              vm.file.name = file.name;
              vm.file.short = file.short;
              vm.file._id = file._id;
              vm.fileref = file._id;
              vm.asyncSelected = file.short;
              vm.parentsave({file: vm.file, fileref: vm.fileref});
            }, function (err) {
              vm.error = true;
              $log.error(err);
            });
          }


          // typeahead file search backend query
          function getFiles(val) {
            // return Fileahead.$search({query: val}).$asPromise().then(function (response) {
            return File.$searchahead({query: val}).$asPromise().then(function (response) {
              return response.map(function (file) {
                file.text = file.short;
                delete vm.error;
                return file;
              });
            });
          }

          // typeahead file search action
          function showfile($item, $model, $label) {
            /* eslint "no-unused-vars": [0, {"args": "none"}] */
            vm.file = $model;
            vm.fileref = $model._id;
            delete vm.asyncSelected;
            vm.editinplace = true;
            $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
            if (vm.editinplace === true) {
              vm.file = $model;
              vm.fileref = $model._id;
              $log.debug('debug - filesearch editinplace');
            }
            else {
              vm.file = {};
              vm.file.name = $model.name;
              vm.file.short = $model.short;
              vm.file._id = $model._id;
              vm.fileref = $model._id;
              vm.parentsave({file: vm.file, fileref: vm.fileref});
              $log.debug('debug - filesearch do not  editinplace', vm.parentsave);
            }
          }

          function save() {
            if (!angular.equals(vm.file, vm.lastfile) || !angular.equals(vm.fileref, vm.lastfileref)) {
              vm.lastfile = angular.copy(vm.file);
              vm.lastfileref = angular.copy(vm.fileref);
              vm.parentsave({file: vm.file, fileref: vm.fileref});
            }
          }


        }] // controller
    }); // component

// klammerfriedhof
}());
